<template>
  <div>
    <SlideShowSection />
    <QualitySealSection />
    <AboutSection />
    <ServicesSection />
    <ClientsSection />

    <VideosSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import QualitySealSection from "../components/sections/QualitySealSection.vue";
import AboutSection from "../components/sections/AboutSection.vue";
import ServicesSection from "../components/sections/ServicesSection.vue";
import ClientsSection from "../components/sections/ClientsSection.vue";

import VideosSection from "../components/sections/VideosSection.vue";

export default {
  components: {
    SlideShowSection,
    QualitySealSection,
    AboutSection,
    ServicesSection,
    ClientsSection,
    VideosSection,
  },
};
</script>
